import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-of-duty',
  templateUrl: './call-of-duty.component.html',
  styleUrls: ['./call-of-duty.component.css']
})
export class CallOfDutyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
